import React, { CSSProperties } from 'react';
import { Button, Popup } from 'antd-mobile';
import './index.scss';

export interface PopupProps {
  className?: string;
  visible: boolean;
  children?: React.ReactNode;
  position?: 'bottom' | 'top' | 'left' | 'right';
  title?: string;
  titleAlign?: 'left' | 'center' | 'right';
  hasClose?: boolean;
  customClose?: React.ReactNode;
  onClose?: () => void;
  closeOnMaskClick?: boolean;
  bodyStyle?: CSSProperties;
  destroyOnClose?: boolean;
  footer?: {
    onClick?: () => void;
    btnText: string;
    color: 'default' | 'primary' | 'success' | 'warning' | 'danger';
    fill: 'solid' | 'outline' | 'none';
    disabled?: boolean;
    loading?: boolean;
    otherStyle?: CSSProperties; // 允许外部覆盖或补充按钮样式
  }[];
}

// 使用传统函数声明代替箭头函数，兼容ES2015
function CommonPopup(props: PopupProps) {
  // 使用传统方式解构对象，避免使用解构赋值语法
  const className = props.className;
  const visible = props.visible;
  const children = props.children;
  const position = props.position || 'right';
  const title = props.title;
  const titleAlign = props.titleAlign || 'center';
  const hasClose = props.hasClose;
  const onClose = props.onClose;
  const closeOnMaskClick = props.closeOnMaskClick;
  const destroyOnClose =
    props.destroyOnClose !== undefined ? props.destroyOnClose : true;
  const footer = props.footer;
  const bodyStyle = props.bodyStyle;
  const customClose = props.customClose;

  return (
    <Popup
      visible={visible}
      closeOnMaskClick={closeOnMaskClick}
      destroyOnClose={destroyOnClose}
      onClose={onClose}
      bodyStyle={bodyStyle}
      position={position}
    >
      <div className={'common-popup-container ' + (className || '')}>
        {(title || hasClose) && (
          <div className={'popup-header ' + titleAlign}>
            {title && <h1>{title}</h1>}
            {hasClose && <i className="close-btn" onClick={onClose}></i>}
          </div>
        )}
        {children && <div className="popup-body">{children}</div>}
        {footer && (
          <div className="popup-footer">
            {/* 使用条件检查代替可选链操作符 */}
            {footer &&
              footer.map(function (item, index) {
                // 创建按钮属性对象，避免使用展开运算符
                const buttonProps = {
                  color: item.color,
                  fill: item.fill,
                  disabled: item.disabled,
                  loading: item.loading,
                  onClick: function () {
                    if (item.onClick) {
                      item.onClick();
                    }
                  }
                };

                // 默认样式
                const defaultStyle: CSSProperties = {
                  '--border-radius': '8px',
                  '--background-color':
                    buttonProps.fill === 'outline' ? 'transparent' : '#3C6EF0'
                } as CSSProperties;
                // 合并外部样式，外部优先生效
                const finalStyle = Object.assign(
                  {},
                  defaultStyle,
                  item.otherStyle || {}
                );

                return (
                  <Button
                    key={index}
                    color={buttonProps.color}
                    fill={buttonProps.fill}
                    disabled={buttonProps.disabled}
                    loading={buttonProps.loading}
                    onClick={buttonProps.onClick}
                    style={finalStyle}
                  >
                    {item.btnText}
                  </Button>
                );
              })}
          </div>
        )}
      </div>
      {customClose && customClose}
    </Popup>
  );
}

export default CommonPopup;
